import { User } from "@app/shared/models";

export enum SampleBoardBuildEventType {
    Start = 1,
    Pause = 2,
    Resume = 3,
    Close = 4,
}

export class SampleBoardBuildEvent {
    id: number;
    eventType: SampleBoardBuildEventType;
    eventDate: string;
    reason?: string;
    author?: User;

    constructor(entry: any = {}) {
        this.id = entry?.id;
        this.eventType = entry?.eventType;
        this.eventDate = entry?.eventDate;
        this.reason = entry?.reason;
        this.author = entry?.author ? new User(entry.author) : null;
    }
}
